import angular from 'angular';
import { CfgService } from './CfgService.js';
import 'components/sharpr/api/apiModule';

angular.module('sh.cfg', ['sh.api']).service('Cfg', CfgService);
